document.addEventListener("DOMContentLoaded", function () {
  const scrollTopBtn = document.querySelector(".btn--scroll-window--top");
  scrollTopBtn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  window.addEventListener("scroll", () => {
    const quarterScreenHeight = window.innerHeight * .25
    if (window.scrollY < quarterScreenHeight) {
      scrollTopBtn.classList.add("hidden");
    } else {
      scrollTopBtn.classList.remove("hidden");
    }
  });
});
